import dataService from "../../api";

import { status } from "@/utils/common";
import { startLoading, stopLoading, serverErrorMessage, showAlert, showNotification, catchHandler } from "@/utils/helpers";


export default {
    namespaced: true,
    state: {
        appointments: [],
        appointment: {
            id: null,
            fullName: null,
            bloodType: null,
            birthDate: null,
            gender: null,
            disease: [],
            skinIssues: [],
        },
        doctors: [],
        totalItems: 0,
    },
    getters: {
        index: state => (id) => state.appointments.findIndex(i => i.id === id)
    },
    mutations: {
        SET_APPOINTMENTS: (state, data) => state.appointments = data,
        SET_TOTAL_ITEMS: (state, r) => (state.totalItems = r),
        SET_APPOINTMENT: (state, viewData) => state.appointment = viewData,
        SET_DOCTORS: (state, viewData) => state.doctors = viewData,
        ADD: (state, addedData) => state.appointments.unshift(addedData),
        UPDATE: (state, { index, updateData }) => state.appointments.splice(index, 1, updateData),
        // DELETE: (state, index) => state.appointments.splice(index, 1),
        approval: (state, { index, updateData }) => state.appointments.splice(index, 1, updateData),
          servicesApproval: (state, index) => {
            state.appointments[index].enabelProceduresApproval = false;
            state.appointments[index].hasInvoices = true;
          },
                       

        // approval: (state, index) => state.appointments[index].status = status.approved,
        review: (state, index) => state.appointments[index].status = status.review,
        DELETE: (state, index) => state.appointments[index].status = status.rejected,

    },
    actions: {
        async getAll({ commit }, params) {
            startLoading()
            try {
                commit('SET_APPOINTMENTS', []);
                commit('SET_TOTAL_ITEMS', 0);

                const paramsString = Object.entries(params)
                    .filter(([, val]) => val !== null)
                    .map(([key, val]) => `${key}=${val}`)
                    .join("&");

                const response = await dataService.doctorsAppointments.getAll(paramsString);
                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                commit('SET_APPOINTMENTS', response.data.appointments);
                commit('SET_TOTAL_ITEMS', response.data.totalItems);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async getDetails({ commit }, id) {
            startLoading()
            try {
                commit('SET_APPOINTMENT', {});
                const response = await dataService.doctorsAppointments.getDetails(id);
                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                commit('SET_APPOINTMENT', response.data.appointment);
            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async servicesApproval({ commit, getters }, { id, doctorId }) {
            try {
                startLoading()
                const response = await dataService.doctorsAppointments.servicesApproval(id, doctorId);
                stopLoading()

                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                showNotification(response.data.message);


                const index = getters.index(id);

                commit('servicesApproval', index);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async approval({ commit, getters }, { id, doctorId }) {
            try {
                startLoading()
                const response = await dataService.doctorsAppointments.approval(id, doctorId);
                stopLoading()

                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                showNotification(response.data.message);


                const index = getters.index(id);

                commit('approval', { index: index, updateData: response.data.appointment });

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async review({ commit, getters }, { id, payload }) {
            try {
                startLoading()
                const response = await dataService.doctorsAppointments.review(id, payload);
                stopLoading()

                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                showNotification(response.data.message);


                const index = getters.index(id);
                commit("review", index);
            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        // ------------------------ new 22/9--------------------
        async getForEdit(_, id) {
            try {
                startLoading()
                const response = await dataService.doctorsAppointments.getForEdit(id);
                stopLoading()

                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                return Promise.resolve(response.data.appointment);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async getForProcedures(_, id) {
            try {
                startLoading()
                const response = await dataService.doctorsAppointments.getForProcedures(id);
                stopLoading()

                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                return Promise.resolve(response.data.appointment);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        }, 
        
        async getAttachment(_, id) {
            try {
                startLoading()
                const response = await dataService.doctorsAppointments.getAttachment(id);
                stopLoading()

                if (response.status != 200) {
                    showAlert(serverErrorMessage);
                    return;
                }
                return Promise.resolve(response);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async UpdateProcedure({ commit, getters }, { id, payload }) {
            try {

                const formData = new FormData();
                // formData.append("appointmentId", payload.appointmentId);
                formData.append("diagnosisSummary", payload.diagnosisSummary);
                formData.append("treatmentPlan", payload.treatmentPlan??"");
       
                if (payload.file) {
                    formData.append("file", payload.file);
                }

                payload.diseases.forEach((f, i) => {
                    formData.append(`diseases[${i}]`, f.toString());
                });    
                  payload.skinIssues.forEach((f, i) => {
                    formData.append(`skinIssues[${i}]`, f.toString());
                });

                startLoading()
                const response = await dataService.doctorsAppointments.UpdateProcedure(id, formData);
                stopLoading()

                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                showNotification(response.data.message);

                const index = getters.index(id);
                commit("UPDATE", { index, updateData: response.data.appointment });

            } catch (error) {
                stopLoading()
                catchHandler(error);
                return Promise.reject(error);
            }
        },
        async edit({ commit, getters }, { id, payload }) {
            try {
                startLoading()
                const response = await dataService.doctorsAppointments.edit(id, payload);
                stopLoading()

                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                const index = getters.index(id);
                commit("UPDATE", { index, updateData: response.data.appointment });

            } catch (error) {
                stopLoading()
                catchHandler(error);
                return Promise.reject(error);
            }
        },
        //--------------------- 15-12 -------------------------//
         async followUp({ commit, getters }, { id, doctorId }) {
            try {
                startLoading()
                const response = await dataService.doctorsAppointments.followUp(id, doctorId);
                stopLoading()

                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                showNotification(response.data.message);


                const index = getters.index(id);
                commit("UPDATE", { index, updateData: response.data.appointment });
            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
         async unfollowUp({ commit, getters }, { id, doctorId }) {
            try {
                startLoading()
                const response = await dataService.doctorsAppointments.unfollowUp(id, doctorId);
                stopLoading()

                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                showNotification(response.data.message);


                const index = getters.index(id);
                commit("UPDATE", { index, updateData: response.data.appointment });
            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
    },
};
